<div class="filter-modal-container bg-light-surface dark:bg-dark-surface dark:[color-scheme:dark]">
  <!-- Header -->
  <div class="px-6 py-5 flex items-center justify-between border-b border-light-border dark:border-dark-border bg-light-surface dark:bg-dark-surface">
    <div class="flex items-center gap-2.5">
      <div class="w-8 h-8 rounded-lg bg-light-primary/10 dark:bg-dark-primary/20 flex items-center justify-center flex-shrink-0">
        <lucide-angular [img]="SlidersHorizontal" class="w-4 h-4 text-light-primary dark:text-dark-primary"></lucide-angular>
      </div>
      <h2 class="!mb-0">Filtros</h2>
    </div>
    <button
      type="button"
      (click)="dialogRef.close()"
      class="p-1.5 hover:bg-light-bg-tertiary dark:hover:bg-dark-surface-variant rounded-lg transition-colors">
      <lucide-angular [img]="X" class="w-4 h-4 text-light-text-secondary dark:text-dark-text-secondary"></lucide-angular>
    </button>
  </div>

  <!-- Content -->
  <div class="modal-content">
    <!-- Sección de Fechas (Expandible) -->
    <div class="border-b border-light-border dark:border-dark-border">
      <!-- Fila clickeable para expandir -->
      <div
        class="picklist-row"
        (click)="toggleDateFilterExpansion()"
        [class.expanded]="dateFilterExpanded">
        <div class="flex items-center justify-between w-full">
          <span class="text-base text-light-text dark:text-dark-text">Fecha de modificación</span>
          <div class="flex items-center gap-2">
            <!-- Badge con contador si hay fechas activas -->
            @if (getDateFilterCount() > 0) {
              <span
                class="px-2 py-0.5 text-xs font-semibold rounded-full bg-light-primary/15 dark:bg-dark-primary/25 text-light-primary dark:text-dark-primary">
                {{ getDateFilterCount() }}
              </span>
            }
            <!-- Ícono de chevron -->
            <lucide-angular
              [img]="dateFilterExpanded ? ChevronUp : ChevronDown"
              class="w-5 h-5 text-light-text-secondary dark:text-dark-text-secondary">
            </lucide-angular>
          </div>
        </div>
      </div>

      <!-- Panel expandido con campos de fecha -->
      @if (dateFilterExpanded) {
        <div class="px-6 pb-2 pt-2">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <mat-form-field appearance="fill" subscriptSizing="dynamic" class="w-full">
              <mat-label>Desde</mat-label>
              <input matInput [matDatepicker]="pickerFrom" [(ngModel)]="modifiedDateFrom">
              <mat-datepicker-toggle matIconSuffix [for]="pickerFrom"></mat-datepicker-toggle>
              <mat-datepicker #pickerFrom></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="fill" subscriptSizing="dynamic" class="w-full">
              <mat-label>Hasta</mat-label>
              <input matInput [matDatepicker]="pickerTo" [(ngModel)]="modifiedDateTo">
              <mat-datepicker-toggle matIconSuffix [for]="pickerTo"></mat-datepicker-toggle>
              <mat-datepicker #pickerTo></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      }
    </div>

    <!-- Lista de tipos de picklist -->
    <div class="space-y-0">
      @for (state of filterStates(); track trackByTypeId($index, state)) {
        <div class="border-b border-light-border dark:border-dark-border">
          <!-- Fila del tipo de picklist (clickeable para expandir) -->
          <div
            class="picklist-row"
            (click)="toggleExpansion(state.typeId)"
            [class.expanded]="state.expanded">
            <div class="flex items-center justify-between w-full">
              <span class="text-base text-light-text dark:text-dark-text">{{ state.typeName }}</span>
              <div class="flex items-center gap-2">
                <!-- Badge con contador si hay items seleccionados -->
                @if (getSelectedCount(state) > 0) {
                  <span
                    class="px-2 py-0.5 text-xs font-semibold rounded-full bg-light-primary/15 dark:bg-dark-primary/25 text-light-primary dark:text-dark-primary">
                    {{ getSelectedCount(state) }}
                  </span>
                }
                <!-- Ícono de chevron -->
                <lucide-angular
                  [img]="state.expanded ? ChevronUp : ChevronDown"
                  class="w-5 h-5 text-light-text-secondary dark:text-dark-text-secondary">
                </lucide-angular>
              </div>
            </div>
          </div>
          <!-- Panel expandido con búsqueda e items -->
          @if (state.expanded) {
            <div class="px-6">
              <!-- Campo de búsqueda -->
              <div class="px-2 py-1 mb-1 mt-1 border border-light-border dark:border-dark-border rounded-[10px]">
                <div class="relative">
                  <div class="flex gap-2 items-center">
                    <lucide-angular
                      [img]="Search"
                      class="w-4 h-4 text-light-text-tertiary dark:text-dark-text-tertiary">
                    </lucide-angular>
                    <input
                      type="text"
                      [value]="state.searchQuery"
                      (input)="updateSearchQuery(state.typeId, $any($event.target).value)"
                      placeholder="Buscar..."
                      class="text-light-text-tertiary dark:text-dark-text-tertiary bg-light-surface dark:bg-dark-surface outline-none"
                      (click)="$event.stopPropagation()" />
                  </div>
                  @if (state.searchQuery) {
                    <button
                      type="button"
                      (click)="clearSearch(state.typeId); $event.stopPropagation()"
                      class="absolute right-3 top-1/2 -translate-y-1/2 text-light-text-tertiary dark:text-dark-text-tertiary hover:text-light-text dark:hover:text-dark-text">
                      <lucide-angular [img]="X" class="w-4 h-4"></lucide-angular>
                    </button>
                  }
                </div>
              </div>
              <!-- Lista de items con checkboxes -->
              <div class="items-list space-y-1">
                @for (item of getFilteredItems(state); track trackByItemId($index, item)) {
                  <div
                    class="flex gap-2 items-center"
                    (click)="toggleItemSelection(state.typeId, item.picklistItemId); $event.stopPropagation()">
                    <mat-checkbox
                      [checked]="isItemSelected(state.typeId, item.picklistItemId)"
                      (change)="toggleItemSelection(state.typeId, item.picklistItemId)"
                      (click)="$event.stopPropagation()"
                      color="primary">
                      <span class="text-xs text-light-text dark:text-dark-text break-all">{{ item.name }}</span>
                    </mat-checkbox>
                  </div>
                }
                <!-- Mensaje cuando no hay resultados -->
                @if (getFilteredItems(state).length === 0) {
                  <div class="p-4 flex items-center justify-center">
                    <p class="text-sm text-light-text-tertiary dark:text-dark-text-tertiary !pb-0 !mb-0">No se encontraron resultados</p>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>

    <!-- Sección de Búsqueda por Texto (Expandible) -->
    <div class="border-b border-light-border dark:border-dark-border">
      <!-- Fila clickeable para expandir -->
      <div
        class="picklist-row"
        (click)="toggleTextSearchExpansion()"
        [class.expanded]="textSearchExpanded">
        <div class="flex items-center justify-between w-full">
          <span class="text-base text-light-text dark:text-dark-text">Buscar por texto</span>
          <div class="flex items-center gap-2">
            <!-- Badge con contador si hay búsquedas activas -->
            @if (getTextSearchCount() > 0) {
              <span
                class="px-2 py-0.5 text-xs font-semibold rounded-full bg-light-primary/15 dark:bg-dark-primary/25 text-light-primary dark:text-dark-primary">
                {{ getTextSearchCount() }}
              </span>
            }
            <!-- Ícono de chevron -->
            <lucide-angular
              [img]="textSearchExpanded ? ChevronUp : ChevronDown"
              class="w-5 h-5 text-light-text-secondary dark:text-dark-text-secondary">
            </lucide-angular>
          </div>
        </div>
      </div>

      <!-- Panel expandido con campos de búsqueda -->
      @if (textSearchExpanded) {
        <div class="px-6 py-2 space-y-2">
          <!-- Identificador -->
          <mat-form-field appearance="fill" subscriptSizing="dynamic" class="w-full">
            <mat-label>Identificador</mat-label>
            <input matInput [(ngModel)]="identifier" placeholder="ej: ART-">
            <lucide-angular [img]="Search" class="w-4 h-4 text-light-text-tertiary dark:text-dark-text-tertiary" matIconPrefix></lucide-angular>
          </mat-form-field>
          <!-- Contenido -->
          <mat-form-field appearance="fill" subscriptSizing="dynamic" class="w-full">
            <mat-label>Contenido</mat-label>
            <input matInput [(ngModel)]="content" placeholder="Buscar en el contenido del artículo">
            <lucide-angular [img]="Search" class="w-4 h-4 text-light-text-tertiary dark:text-dark-text-tertiary" matIconPrefix></lucide-angular>
          </mat-form-field>
          <!-- Palabras Clave -->
          <mat-form-field appearance="fill" subscriptSizing="dynamic" class="w-full">
            <mat-label>Palabras Clave</mat-label>
            <input matInput [(ngModel)]="keywords" placeholder="Buscar por palabras clave">
            <lucide-angular [img]="Search" class="w-4 h-4 text-light-text-tertiary dark:text-dark-text-tertiary" matIconPrefix></lucide-angular>
          </mat-form-field>
          <!-- Protocolo -->
          <mat-form-field appearance="fill" subscriptSizing="dynamic" class="w-full">
            <mat-label>Protocolo</mat-label>
            <input matInput [(ngModel)]="protocol" placeholder="Buscar por protocolo">
            <lucide-angular [img]="Search" class="w-4 h-4 text-light-text-tertiary dark:text-dark-text-tertiary" matIconPrefix></lucide-angular>
          </mat-form-field>
        </div>
      }
    </div>
  </div>

  <!-- Footer con botones -->
  <div class="modal-footer">
    <button
      (click)="clearAndReload()"
      [disabled]="!hasActiveFilters()"
      class="flex-1 !py-1.5 rounded-[12px] font-medium !text-light-text-secondary dark:!text-dark-text-secondary hover:!bg-light-bg-tertiary dark:hover:!bg-dark-surface-variant transition-all duration-200">
      Limpiar
    </button>
    <button
      (click)="applyFilters()"
      [disabled]="!hasActiveFilters()"
      class="flex-1 bg-light-primary dark:bg-dark-primary text-white rounded-[12px] font-medium hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed">
      Aplicar
    </button>
  </div>
</div>